module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-tokai-4-d29ffceac57e5b711a39e4c4549f1009.jpg";